import { SlideEditorProvider } from "@/components/slides/editor/SlideEditorContext";
import { SelectionProvider } from "@/contexts/SelectionContext";
import { SlidePage } from "@/pages/slide/SlidePage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/slide/$slideId")({
  component: WrappedSlidePage,
});

function WrappedSlidePage() {
  return (
    <SelectionProvider>
      <SlideEditorProvider>
        <SlidePage />
      </SlideEditorProvider>
    </SelectionProvider>
  );
}
